__turbopack_context__.v({
  "darkIcon": "styles-module-scss-module__U8Y3Sa__darkIcon",
  "icon": "styles-module-scss-module__U8Y3Sa__icon",
  "iconWrapper": "styles-module-scss-module__U8Y3Sa__iconWrapper",
  "isProviders": "styles-module-scss-module__U8Y3Sa__isProviders",
  "lightIcon": "styles-module-scss-module__U8Y3Sa__lightIcon",
  "link": "styles-module-scss-module__U8Y3Sa__link",
  "linkArrow": "styles-module-scss-module__U8Y3Sa__linkArrow",
  "root": "styles-module-scss-module__U8Y3Sa__root",
  "root3D": "styles-module-scss-module__U8Y3Sa__root3D",
  "title": "styles-module-scss-module__U8Y3Sa__title",
  "titleWithLink": "styles-module-scss-module__U8Y3Sa__titleWithLink",
});
